(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const dialog = document.getElementById('g4-phone-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const link = event.target.closest('a[href^="tel:"]');
  if (link && !link.hasAttribute('data-phone-action')) {
    event.preventDefault();
    const number = link.getAttribute('href').slice(4).replace(/[^+0-9]/g, '');
    dialog.querySelector('[data-phone-action="call"]').href = 'tel:' + number;
    dialog.querySelector('[data-phone-action="text"]').href = 'sms:' + number;
    const digits = number.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
    dialog.querySelector('h2').textContent = digits.length === 10 ? '(' + digits.slice(0,3) + ') ' + digits.slice(3,6) + '-' + digits.slice(6) : number;
    dialog.showModal();
  }
  if (event.target.closest('.g4-phone-close')) dialog.close();
  if (event.target === dialog) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }
});

  } catch(e) { console.error(e); }
})();
})();
